<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Employee Salary Structure</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo"> <span class="required">*</span> Salary Type </label>
                        <v-select
                            placeholder="Select Salary Type"
                            v-model="formData.salary_type"
                            :options="salaryType"
                            :reduce="name => name.value"
                            label="name"
                        />
                      </div>
                    </div>

                    <div v-if="formData.salary_type == 'monthly_payscale'" class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo"> Salary Grade  </label>
                        <v-select
                            placeholder="Select Salary Grade Scale"
                            v-model="salaryGrade"
                            :options="salaryGradeData"
                            :reduce="name => name.grade_serial"
                            label="grade_number"
                        />
                      </div>
                    </div>

                    <div v-if="formData.salary_type == 'monthly_payscale'" class="col-12">
                    <div class="mb-1">
                        <label class="form-label" for="mobileNo"> Salary Scale </label>
                        <v-select
                            placeholder="Select Salary Scale"
                            v-model="salaryGradeScaleId"
                            :options="salaryGradeScaleData"
                            :reduce="name => name"
                            label="name"
                        />
                      </div>
                    </div>

                    <div class="row" v-for="(payHead, index) in payHeads" :key="payHead.id">
                      <div class="col-6">
                        <label class="form-label" for="mobileNo"><span class="fw-bolder">{{ payHead.name }}</span> <br> <span>({{ payHead.calculation_type_name }})</span></label>
                      </div>
                      <div class="col-6">
                        <div class="mb-1">
                          <input
                              type="number"
                              :disabled="formData.pay_heads[index].pay_head_id == null"
                              class="form-control"
                              placeholder="Enter amount"
                              v-model.number="formData.pay_heads[index].pay_head_amount"
                              @input="onCustomInput(index)"
                          />
                          <input type="hidden" v-model="formData.pay_heads[index].pay_head_id" />
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo"> <span class="required">*</span> Effective Date </label>
                        <input
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="date"
                            placeholder=""
                            v-model="formData.effective_date"
                        >
                      </div>
                    </div>

                    <div class="col-6 text-center mb-2 mt-2">
                      <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                        <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        Submit
                      </button>
                    </div>
                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import { inject, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';

const props = defineProps({
   isEdit:{
     type:Boolean,
     default:false
   },
    formData:{
      type:Object,
      default:{}
    },
    salaryStructureData:{
      default:[]
    },
    salaryStructureGradeData: {
       default:{}
    }
});

const emit = defineEmits(['submitted']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const loader = ref(false);
const salaryGrade = ref(null);
const salaryGradeScaleId = ref(null);
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const salaryType = ref([]);
const payHeads = ref([]);
const salaryGradeData = ref([]);
const salaryGradeScaleData = ref([]);
const {
  fetchPayHead,
  fetchTypes,
  createSalaryStructure,
  fetchSalaryGradeScale
} = handleHrPayroll()

const submit = async() => {
    const query = getQuery();
    loading.value = true;
    await storeData(query)
}

watch(salaryGrade, async (newGrade) => {
  if (newGrade) {
    await getSalaryGradeScale(newGrade)
  }
});

watch(() => salaryGradeScaleId.value, (newValue) => {
  if (newValue) {
    props.formData.salary_grade_scale_id = newValue.value
    props.formData.pay_heads.forEach((payHead, index) => {
      if (payHead.calculation_type === 'user_defined') {
       props.formData.pay_heads[index].pay_head_amount = newValue.amount;
      }
    });
  }
});

function mapPayHead(ph, matched, grossComponent = 0) {
  const payHeadAmount = ph.calculation_type === 'fixed_amount' ? ph.value : 0
  return {
    pay_head_id: ph.id,
    pay_head_amount: matched ? matched.pay_head_amount : payHeadAmount,
    name: ph.name,
    calculation_type: ph.calculation_type,
    calculation_type_name: ph.calculation_type_name,
    pay_head: ph.pay_head_id,
    value: ph.value,
    gross_salary_component: grossComponent,
    custom_input: false
  };
}

function onCustomInput(index) {
  props.formData.pay_heads[index].custom_input = true;
}

const getPayHead = async () => {
  payHeads.value = [];
  loading.value = true;

  let query = getQuery();
  query += '&is_all=1&income_type=fixed';

  try {
    const res1 = await fetchPayHead(`${query}&gross_salary_component=1&payroll_category=salary,bonus,overtime,other_allowance`);
    const res2 = await fetchPayHead(`${query}&gross_salary_component=0&payroll_category=salary,bonus,overtime,other_allowance`);

    let grossComponentData = res1.status ? res1.data.map(ph => {
      const matched = props.salaryStructureData.find(s => s.pay_head_id === ph.id);
      return mapPayHead(ph, matched, 1);
    }) : []

    const grossSalary = grossComponentData.reduce((sum, item) => sum + Number(item.pay_head_amount || 0), 0);
    grossComponentData.push({
      pay_head_id: null,
      pay_head_amount: grossSalary,
      name: 'Gross Salary',
      calculation_type: 'Summary',
      calculation_type_name: 'Summary',
      pay_head: null,
      value:null,
      gross_salary_component:0
    });

    const payHeadData = res2.status ? res2.data.map(ph => {
      const matched = props.salaryStructureData.find(s => s.pay_head_id === ph.id);
      return mapPayHead(ph, matched, 0);
    }) : [];

    const allData = [...grossComponentData, ...payHeadData];

    payHeads.value = allData;
    props.formData.pay_heads = allData;

  } catch (err) {
    console.log(err);
  } finally {
    loading.value = false;
  }
};

const getSalaryGrade = async () => {
  const query = getQuery();
  loading.value = true
  salaryGradeData.value = []

  await fetchSalaryGradeScale(query).then(res => {
    if (!res.status){
      return
    }
    salaryGradeData.value = res.data.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getSalaryGradeScale = async (gradeSerial) => {
  let query = getQuery();
  query += '&grade_serial=' + gradeSerial
  loading.value = true
  salaryGradeScaleData.value = []

  await fetchSalaryGradeScale(query).then(res => {
    if (!res.status){
      return
    }

    let data = res.data.data && res.data.data[0]

    salaryGradeScaleData.value = Object.entries(data.scale_data).map(([key, value]) => ({
      name: data.grade_number + '(' + value + ')',
      value: key,
      amount: value
    }));

  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

watch(() => props.salaryStructureGradeData, (newVal) => {
  if (newVal && newVal.grade_number && newVal.grade_serial) {
    salaryGrade.value = {
      grade_number: newVal.grade_number,
      value: newVal.grade_serial
    }
    getSalaryGradeScale(newVal.grade_serial)
  }

  if (newVal && newVal.scale_amount && newVal.scale_id) {
    salaryGradeScaleId.value = {
      name: newVal.grade_number + '(' + newVal.scale_amount + ')',
      value: newVal.scale_id
    }
  }

}, { deep: true });

watch(
    () => props.formData.pay_heads.map(ph => ph.pay_head_amount),
    () => {
      const payHeads = props.formData.pay_heads;

      const gross = payHeads
          .filter(ph => ph.gross_salary_component === 1)
          .reduce((sum, ph) => sum + Number(ph.pay_head_amount || 0), 0);

      for (const ph of payHeads) {
        if (ph.custom_input || props.formData.is_edit) continue;

        const base = ph.calculation_type === 'percentage_of_pay_head' && ph.value && ph.pay_head !== null
            ? payHeads.find(p => p.pay_head_id === ph.pay_head)
            : null;

        if (base) {
          ph.pay_head_amount = (base.pay_head_amount * ph.value) / 100;
          continue;
        }

        if (ph.calculation_type === 'percentage_of_gross_salary' && ph.value) {
          ph.pay_head_amount = (gross * ph.value) / 100;
        }
      }

      const summary = payHeads.find(ph => ph.pay_head_id === null);
      if (summary) {
        summary.pay_head_amount = gross;
      }
    },
    { deep: true }
);

const storeData = async (query) => {
  let salaryStructureData = {};
  salaryStructureData.company_id = $route.params.companyId;
  salaryStructureData.contact_profile_id = props.formData.contact_profile_id;
  salaryStructureData.effective_date = props.formData.effective_date;
  salaryStructureData.salary_type = props.formData.salary_type;
  salaryStructureData.salary_grade_scale_id = (props.formData.salary_grade_scale_id && props.formData.salary_type == 'monthly_payscale') ?
      Number(props.formData.salary_grade_scale_id) : null;
  salaryStructureData.pay_heads = props.formData.pay_heads;

  await createSalaryStructure(salaryStructureData, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("submitted");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickClose = () => {
    props.formData.salary_type = null;
    props.formData.is_edit = null;
    $store.state.isModalOpenTwo = false;
}

const getTypes = async () => {
  let query = getQuery();
  await fetchTypes(query).then(res => {
    if (!res.status){
      salaryType.value = [];
      return
    }

    const data = res.data || {};
    salaryType.value = data.salaryType || [];
  }).catch(err => {
    console.log(err)
  })
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

onMounted(() => {
  props.formData.effective_date = new Date().toISOString().split('T')[0]
  getPayHead()
  getTypes()
  getSalaryGrade()
})
</script>
